export enum NavigationStateType{
  Default = 0,
  Command = 1
}
